<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="true"
      :selectShow="false"
      addShowPower="/onlineapplicationcardmanage/add"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="stateName"
        label="阶段"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="selfPercent"
        label="申卡本人佣金（%）"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="parentPercent"
        label="直推上级佣金（%）"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="parentIdentity"
        label="上级身份"
        min-width="220"
        :formatter="formatterTableparentIdentity"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="firstPercent"
        label="初伙佣金（%）"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="midPercent"
        label="中伙佣金（%）"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="highPercent"
        label="高伙佣金（%）"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPerm('/apppointsnewodetojoymanage/update')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/apppointsnewodetojoymanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="460px"
    >
      <el-form-item label-width="180px" label="阶段" prop="state">
        <el-select v-model="dialogModel.state" style="width: 200px">
          <el-option
            v-for="item in JieDuan"
            :key="item.state"
            :label="item.stateName"
            :value="item.state"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label-width="180px"
        label="申卡本人佣金（%）"
        prop="selfPercent"
      >
        <el-input-number
          v-model="dialogModel.selfPercent"
          :controls="false"
          :precision="2"
          :step="0.1"
          controls-position="right"
          :min="0"
          :max="100"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label-width="180px"
        label="直推上级佣金（%）"
        prop="parentPercent"
      >
        <el-input-number
          v-model="dialogModel.parentPercent"
          :controls="false"
          :precision="2"
          :step="0.1"
          controls-position="right"
          :min="0"
          :max="100"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="180px" label="上级身份" prop="parentIdentity">
        <el-select v-model="dialogModel.parentIdentity" style="width: 200px">
          <el-option
            v-for="item in seatList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <span style="display: block; margin-bottom: 15px">合伙人佣金配置</span>
      <el-form-item
        label-width="180px"
        label="初伙佣金（%）"
        prop="firstPercent"
      >
        <el-input-number
          v-model="dialogModel.firstPercent"
          :controls="false"
          :precision="2"
          :step="0.1"
          controls-position="right"
          :min="0"
          :max="100"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="180px" label="中伙佣金（%）" prop="midPercent">
        <el-input-number
          v-model="dialogModel.midPercent"
          :controls="false"
          :precision="2"
          :step="0.1"
          controls-position="right"
          :min="0"
          :max="100"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label-width="180px"
        label="高伙佣金（%）"
        prop="highPercent"
      >
        <el-input-number
          v-model="dialogModel.highPercent"
          :controls="false"
          :precision="2"
          :step="0.1"
          controls-position="right"
          :min="0"
          :max="100"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="180px" label="开关" prop="status">
        <el-switch
          v-model="dialogModel.status"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import OnlineService from "service/OnlineService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "onlineapplicationcardmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      show: false,
      formModel: {},
      tableData: [],
      seatList: [
        {
          id: 0,
          levelName: "无限制",
        },
        {
          id: 1,
          levelName: "经销商",
        },
      ],
      JieDuan: [],
      submitService: OnlineService.onlineapplicationcardmanageList,
      itemId: "",
      dialogModel: {
        state: "",
        stateName: "",
        selfPercent: undefined,
        parentPercent: undefined,
        parentIdentity: "",

        firstPercent: undefined,
        midPercent: undefined,
        highPercent: undefined,

        status: "0",
      },
      dialogRules: {
        state: [
          {
            required: true,
            message: "请选择",
          },
        ],
        selfPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        parentPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        parentIdentity: [
          {
            required: true,
            message: "请选择",
          },
        ],

        firstPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        midPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
        highPercent: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      const params = {
        typeCode: "agent",
      };
      return params;
    },
    dialogData() {
      const params = {
        state: this.dialogModel.state,
        stateName: this.dialogModel.stateName,
        selfPercent: this.dialogModel.selfPercent,
        parentPercent: this.dialogModel.parentPercent,
        parentIdentity: this.dialogModel.parentIdentity,

        firstPercent: this.dialogModel.firstPercent,
        midPercent: this.dialogModel.midPercent,
        highPercent: this.dialogModel.highPercent,

        status: this.dialogModel.status,

        typeCode: "agent",
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      console.log(params);
      return params;
    },
    dialogService() {
      return this.itemId
        ? OnlineService.onlineapplicationcardmanageUpdate
        : OnlineService.onlineapplicationcardmanageInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "dialogModel.state"(val, oldVal) {
      const jieDuan = this.JieDuan.find((item) => item.state == val);
      if (jieDuan) {
        this.dialogModel.stateName = jieDuan.stateName;
      }
    },
  },
  methods: {
    load() {
      this.formModel = {};
      this.getList();
      this.getJieDuan();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    getJieDuan() {
      this.doLoad(
        OnlineService.onlineapplicationcardmanageJd,
        {
          tatSimpleId: this.$route.params.simpleTatId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.JieDuan = result;
          });
        },
        "信息获取失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        OnlineService.onlineapplicationcardmanageStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        state: "",
        stateName: "",
        selfPercent: undefined,
        parentPercent: undefined,
        parentIdentity: "",

        firstPercent: undefined,
        midPercent: undefined,
        highPercent: undefined,

        status: "0",
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
    formatterTableparentIdentity(row, column, cellValue, index) {
      let value = "--";
      this.seatList.forEach((item) => {
        if (item.id == cellValue) {
          value = item.levelName;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OnlineApplicationCard/OnlineApplicationCardManage.vue